import queryString from 'query-string';
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import useProfessional from 'src/Professional/hooks/useProfessional';
import useSearchHours from 'src/SearchHours/hooks/useSearchHours';
import { filterSearchSelectedState } from 'src/SearchHours/state/atoms';
import { decryptString } from 'src/shared/global/cryptoJSUtilities';
import ManageStorage from 'src/shared/global/manageStorage';

const TotemAgenda = () => {
    const query = queryString.parse(window.location.search, { decode: false })
    const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);

    useEffect(() => {
        (async function () {
            if (query.totem && query.totem == "ok") {
                ManageStorage.setItemStorage("TOTEM","OK");
            }else{
                ManageStorage.removeItemFromStorage("TOTEM");
            }
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null;
}

export default TotemAgenda